import { useState } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import {
  getNextPaginationPage,
  composePaginationSchema,
} from "../../../../../../schemas/pagination";
import { HTTP_ENDPOINTS, ORDER_TYPES } from "../../../../../../consts/api";

export const useAspireRedemption = (params, options = {}) => {
  const [order, setOrder] = useState({
    by: "",
    order: "",
  });

  const updateOrder = (orderFieldKey) => {
    setOrder({
      by: orderFieldKey,
      order:
        order.order === ORDER_TYPES.desc ? ORDER_TYPES.asc : ORDER_TYPES.desc,
    });
  };

  const res = useInfiniteQuery({
    queryKey: ["aspireredemptionReport", params, order],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await http.get(HTTP_ENDPOINTS.getAspireRedemptionReport(), {
        params: {
          ...params,
          pagesize: 15,
          page: pageParam,
          sortBy: order.by,
          sortOrder: order.order,
        },
      });

      const composeResponse = {
        ...composePaginationSchema({
          response: res?.data?.data || {},
          pageSize: 15,
        }),
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        reportHeader: res.data.data.report_header,
      };
      return composeResponse;
    },
    ...options,
    getNextPageParam: getNextPaginationPage,
  });

  return {
    data: res.data,
    isLoading: res.isLoading,
    order: {
      value: order,
      update: updateOrder,
    },
  };
};
